// extracted by mini-css-extract-plugin
export default {"desc":"Description_desc__wLBIa","descp":"Description_descp__bgwCL","options":"Description_options__Lpdm4","active":"Description_active__c+VjS"};